var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___NndtdU",
  "Un": "AuthPageStyles.module__errorContainer___NndtdU",
  "ik": "AuthPageStyles.module__errorIcon___NndtdU",
  "gi": "AuthPageStyles.module__errorIconSvg___NndtdU",
  "JU": "AuthPageStyles.module__errorTitle___NndtdU",
  "kc": "AuthPageStyles.module__errorText___NndtdU",
  "kL": "AuthPageStyles.module__container___NndtdU",
  "TQ": "AuthPageStyles.module__entityHeader___NndtdU",
  "Ep": "AuthPageStyles.module__entityDetails___NndtdU",
  "Pp": "AuthPageStyles.module__entityText___NndtdU",
  "j2": "AuthPageStyles.module__entityTitleWrapper___NndtdU",
  "wD": "AuthPageStyles.module__entityTitle___NndtdU",
  "N2": "AuthPageStyles.module__entityStats___NndtdU",
  "So": "AuthPageStyles.module__entityStat___NndtdU",
  "RS": "AuthPageStyles.module__onlineDot___NndtdU",
  "FD": "AuthPageStyles.module__offlineDot___NndtdU",
  "KA": "AuthPageStyles.module__statText___NndtdU",
  "Wp": "AuthPageStyles.module__entityIconWrapper___NndtdU",
  "fq": "AuthPageStyles.module__entityIcon___NndtdU",
  "Ly": "AuthPageStyles.module__themeIconSpot___NndtdU",
  "J3": "AuthPageStyles.module__themeIcon___NndtdU",
  "Zd": "AuthPageStyles.module__form___NndtdU",
  "ee": "AuthPageStyles.module__registrationNotice___NndtdU",
  "Gr": "AuthPageStyles.module__bottomLink___NndtdU",
  "fH": "AuthPageStyles.module__bottomLinkText___NndtdU",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___NndtdU",
  "cB": "AuthPageStyles.module__usernameHint___NndtdU",
  "Jy": "AuthPageStyles.module__suggestionLink___NndtdU",
  "LB": "AuthPageStyles.module__usernameError___NndtdU",
  "$M": "AuthPageStyles.module__consentRow___NndtdU",
  "t6": "AuthPageStyles.module__consentLabel___NndtdU",
  "Rf": "AuthPageStyles.module__policyLink___NndtdU",
  "ii": "AuthPageStyles.module__disabledContainer___NndtdU",
  "aV": "AuthPageStyles.module__disabledText___NndtdU",
  "ax": "AuthPageStyles.module__disabledSubtext___NndtdU",
  "SO": "AuthPageStyles.module__disabledActions___NndtdU",
  "ns": "AuthPageStyles.module__disabledActionLink___NndtdU",
  "DD": "AuthPageStyles.module__title___NndtdU",
  "Zo": "AuthPageStyles.module__giftIconContainer___NndtdU",
  "ez": "AuthPageStyles.module__giftIcon___NndtdU",
  "PM": "AuthPageStyles.module__entitySubtext___NndtdU",
  "W$": "AuthPageStyles.module__subtext___NndtdU",
};

module.exports = exports;
